import {
    CORE_LOGIN_REQUEST,
    CORE_LOGIN_SUCCESS,
    CORE_LOGIN_FAILURE,

    CORE_EXTEND_REQUEST,
    CORE_EXTEND_SUCCESS,
    CORE_EXTEND_FAILURE,

    CORE_DELETE_REQUEST,
    CORE_DELETE_SUCCESS,
    CORE_DELETE_FAILURE,
} from '../../types'

const initialState = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CORE_LOGIN_REQUEST:
        case CORE_EXTEND_REQUEST:
        case CORE_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            }
        case CORE_LOGIN_SUCCESS:
        case CORE_EXTEND_SUCCESS:
        case CORE_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            }
        case CORE_LOGIN_FAILURE:
        case CORE_EXTEND_FAILURE:
        case CORE_DELETE_FAILURE:
            let { statusText, code, message } = action.payload
            let returnData = {
                ...state,
                isLoading: false,
                hasError: true,
                statusText: statusText,
                errorCode: code,
                errorMessage: message
            }
            return returnData

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/display/features/ui/reducer.js